var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.loading)?_c('v-progress-circular',{staticClass:"loader",attrs:{"color":"#FC7800","indeterminate":"","size":"200","width":"15"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }